export default {
  REFRESH: "refresh",
};
